import React, { Component, createRef } from 'react'
import { connect } from 'react-redux'
import saveAs from 'file-saver';
import { languageSwitchItem } from '../actions/locales'
import i18next from 'i18next'
import { JSEncrypt } from 'jsencrypt'
import aes from 'crypto-js/aes'
import { cipher } from '../actions/stringEncodersFuncs'
import { createSession, sendInputData, sendSessionOption, sendKeyContainer, decryptData,
			getDecryptedData, deleteSession, sendTokenPath, getDecryptorStatus, decryptVtco, premission2fVtco, premissionVtco,
			getVTokenMpo, deciphermentVTokenPass, getVTokenPassResult, getVtcoProtectedParams } from '../actions/api'
import { setInputFileForDecrypt, clearInputFileForDecrypt, setDecryptedData, clearDecryptedData, setDecryptExpand, setErrorData, setShowErrorPopup,
			setInputTypeFor2F, setImageFor2F, setProtectedParams } from '../actions/localStates'
import { bindActionCreators } from 'redux';

import TwoFactorConfirmPopup from '../components/body/TwoFactorConfirmPopup'
import VTokenPassConfirmPopup from '../components/body/VTokenPassConfirmPopup'

import DecryptTextContainer from './DecryptTextContainer'

import Dropzone from 'react-dropzone';

const dropzoneRef = createRef();

class DecryptContainer extends Component {

	constructor(props) {
    super(props);

	    this.state = {
			isLoading: false,
			uuid: null,
			settedToken: null,
			caId: null,
			downloadIsAvailable: true,
			collapseDecryptShow: "",
			showVtcoConfirmPopup: false,
      		numberOfPinInput: 0,
			needToReEnterPin: false,
			showVTokenPassConfirmPopup: false,
            base64ImgForVTokenPass: null,
            mpoTtlMillis: 0,
            codeTtl: 0
		}

		this.withToken = this.withToken.bind(this)
		this.handleOnDrop = this.handleOnDrop.bind(this);

		this.controller = null;
	}

	cancelRequest = () => {
        if (this.controller) {
            this.controller.abort();
            this.setState({isLoading: false})
            this.setState({showVtcoConfirmPopup: false})
            this.setState({showVTokenPassConfirmPopup: false})
        } else {
        	this.setState({isLoading: false})
            this.setState({showVtcoConfirmPopup: false})
        }
    }

	expandDecrypt() {
		this.props.actions.setDecryptExpand(this.props.expandedCardsReducer.decryptExpanded)
		this.props.expandedCardsReducer.decryptExpanded ? this.setState({collapseDecryptShow: "card-body collapse"}) : this.setState({collapseDecryptShow: "card-body collapse show"})
	}

	buildFileForDecryptSelector(){
		const fileForDecrypt = document.getElementById('fileForDecryptUpload');
		return fileForDecrypt;
	}

	componentDidMount(){
		var dropFile = document.getElementById('dropFile');

		this.props.expandedCardsReducer.decryptExpanded ? this.setState({collapseDecryptShow: "card-body collapse show"}) : this.setState({collapseDecryptShow: "card-body collapse"})
    	this.fileForDecrypt = this.buildFileForDecryptSelector();
    	if (!this.props.pkLocalState.isActive) {
			this.cleanUpForm()
		}

		if (dropFile !== null) {
			dropFile.addEventListener('dragenter', function(event) {
				dropFile.style.border = "2px solid steelblue";
			}, false);

			dropFile.addEventListener('dragover', function(event) {
				dropFile.style.border = "2px solid steelblue";
			}, false);

			dropFile.addEventListener('dragleave', function(event) {
				dropFile.style.border = "";
			}, false);
		}
	}

	componentDidUpdate(prevProps) {
		var dropFile = document.getElementById('dropFile');

		if (prevProps.fileForDecryptSelected !== this.props.defaultDecrState.fileForDecryptSelected) {
			if (dropFile !== null) {
				dropFile.addEventListener('dragenter', function(event) {
					dropFile.style.border = "2px solid steelblue";
				}, false);

				dropFile.addEventListener('dragover', function(event) {
					dropFile.style.border = "2px solid steelblue";
				}, false);

				dropFile.addEventListener('dragleave', function(event) {
					dropFile.style.border = "";
				}, false);
			}
		}
	}

	handleFileForDecrypt(e) {
	    e.preventDefault();
	    this.fileForDecrypt.value = null;
	    this.fileForDecrypt.click()
	    document.activeElement.blur()
	}

	onChangeFileForDecrypt(e) {
		if (e.target.files[0] !== undefined && (e.target.files[0].size < 104857600)) {
			this.props.actions.setInputFileForDecrypt(e.target.files[0])
			this.props.actions.clearDecryptedData()
		} else {
			alert(i18next.t("maxFileSizeTitle"))
		}
	}

	handleOnDrop (files) {
		if (files[0] !== undefined && (files[0].size < 104857600)) {
			this.props.actions.setInputFileForDecrypt(files[0])
			this.props.actions.clearDecryptedData()
		}
	}

	cleanUpFileForDecrypt(){
		this.props.actions.clearInputFileForDecrypt()
		this.props.actions.clearDecryptedData()
	}

	cleanUpForm(){
		this.cleanUpFileForDecrypt()
		this.props.actions.clearDecryptedData()
	}

	withToken() {
		var url, _this = this, errorMessage;

		if (this.props.pkLocalState.useUccConnection) {
			url = this.props.base.urlUCC + "/api/v1"
		} else {
			url = this.props.base.urlCloud + "/api/v1"
		}

		var keyContainerPassword
	    if (this.props.pkLocalState.depositsignSelectedKey !== null) {
	        const publicKey = "MIGfMA0GCSqGSIb3DQEBAQUAA4GNADCBiQKBgQCDAChZGnfpj1SsGLIPCaHaL7ybqpMgvphowUroGp7WZ3XA7O3ucaHfIxQFOMNAKUooIkebpp+tLO6imROzxVTmZfySpNNdfBx3E3BU9VzXCBBEKyCrmNxH3AWwuQeoi1Z1ZZLFDI02AjQYR8Nd7TutDGS7FuYlMmIKHYW2+NGHSQIDAQAB";

	        const jsEncrypt = new JSEncrypt();
	        jsEncrypt.setPublicKey(publicKey);

	        if (this.props.pkLocalState.useTwoFactorCode) {
	            keyContainerPassword = aes.encrypt(this.props.pkLocalState.tmpPin, this.props.pkLocalState.tmpTwoFactorCode).toString();
	        } else { 
	            keyContainerPassword = jsEncrypt.encrypt(this.props.pkLocalState.tmpPin);
	        }
	    } else {
	        keyContainerPassword = this.props.pkLocalState.keyContainerPassword
	    }

		this.setState({isLoading: true})
		this.props.actions.createSession(url, _this.props.pkLocalState.useUccConnection ? null : _this.props.base.token)
        	.then((response) => {
				this.setState({uuid: response.ticketUuid})
				console.log(response);
			return this.props.actions.sendInputData(url, this.state.uuid, this.props.defaultDecrState.fileForDecrypt, _this.props.pkLocalState.useUccConnection ? null : _this.props.base.token)
				.then(() => this.props.actions.sendSessionOption(url, this.state.uuid, this.state.caId, _this.props.pkLocalState.useUccConnection ? null : _this.props.base.token))
	            .then(() => this.props.actions.sendTokenPath(url, this.state.uuid, this.state.settedToken, this.props.pkLocalState.depositsignKeysInfo !== null ? this.props.pkLocalState.depositsignKeysInfo.Token : null, _this.props.pkLocalState.useUccConnection ? null : _this.props.base.token))
            	.then(() => this.props.actions.decryptData(url, this.state.uuid, keyContainerPassword, _this.props.pkLocalState.useUccConnection ? null : _this.props.base.token))
	            .then(() => this.props.actions.getDecryptedData(url, this.state.uuid, _this.props.pkLocalState.useUccConnection ? null : _this.props.base.token))
	           	.then((response) => {
	           		if (response !== null) {
            			this.props.actions.setDecryptedData(response)
            		}
                })
                .then(() => this.props.actions.getDecryptorStatus(url, this.state.uuid, _this.props.pkLocalState.useUccConnection ? null : _this.props.base.token))
                .then((response) => {
                	if (response.failureCause !== undefined && response.failureCause.length > 0) {
                    	console.log(response)
                    	errorMessage = {
                          message: response.message,
                          techMessage: response.failureCause
                        }
                        this.props.actions.setErrorData(errorMessage)
                        this.props.actions.setShowErrorPopup(true)

                    	// alert(response.failureCause)
            		} else {
            			// alert(i18next.t("dec:decryptedDataDownloadedSuccess": "decryptedDataDownloadedSuccess"))
            		}
            		this.setState({isLoading: false})
                })
	            .then(() => this.props.actions.deleteSession(url, this.state.uuid, _this.props.pkLocalState.useUccConnection ? null : _this.props.base.token))
        })
	}

	getBlobData() {
	 	var blob;
    	const b64toBlob = (b64Data, contentType, sliceSize = 512) => {
		  const byteCharacters = atob(b64Data);
		  const byteArrays = [];

		  for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
		    const slice = byteCharacters.slice(offset, offset + sliceSize);

		    const byteNumbers = new Array(slice.length);
		    for (let i = 0; i < slice.length; i++) {
		      byteNumbers[i] = slice.charCodeAt(i);
		    }

		    const byteArray = new Uint8Array(byteNumbers);
		    byteArrays.push(byteArray);
		  }

		  const blob = new Blob(byteArrays, {type: contentType});
		  return blob;
		}

		var fileForDownloadName = this.props.defaultDecrState.fileForDecryptName.lastIndexOf(".") < 2 ? this.props.defaultDecrState.fileForDecryptName : this.props.defaultDecrState.fileForDecryptName.substr(0, this.props.defaultDecrState.fileForDecryptName.lastIndexOf("."));
		
		if (fileForDownloadName.length > 0) {
	    	if (this.props.base.isVtco || this.props.base.isVTokenPass) {
	    		blob = b64toBlob(this.props.defaultDecrState.decrData[0]);
	    		saveAs(blob, fileForDownloadName)
	    	} else {
	    		saveAs(this.props.defaultDecrState.decrData, fileForDownloadName);
	    	}
	    }
	}

	selectDecryptVtco () {
		if (this.props.pkLocalState.isTwoFactorEnable) {
			// this.createVtcoSign2f()
			this.setState({numberOfPinInput: this.props.base.numberOfPinInput - 1});
			this.setState({needToReEnterPin: true});
			this.setState({"showVtcoConfirmPopup": true})
		} else {
			this.decryptVtco()
		}
	}

	closeVtcoConfirm (value) {
		if (value === true) {
			this.setState({"showVtcoConfirmPopup": false})
			this.setState({isLoading: false});
			return;
		} else {
			if (this.state.showVtcoConfirmPopup === true && this.state.needToReEnterPin === true) {
				if (this.state.numberOfPinInput > 0) {
					this.decryptVtco2f()
				} else {
					this.setState({needToReEnterPin: false});
					this.setState({numberOfPinInput: 0});
					this.setState({isLoading: false});
				}
			}

			this.setState({"showVtcoConfirmPopup": false})
		}
	}

	decryptVtco2f () {
		this.controller = new AbortController();
		var data, _this = this, errorMessage;
		this.setState({isLoading: true})
		this.setState({"success": 0})
		
		data = {
		    "ciHsmTokenUri": _this.props.pkLocalState.vtcoSelectedKey.uri,
		    "operationType": "DECIPHERMENT",
		    "twoFactorCode" : _this.props.base.inputTypeFor2F === "image" ? "" : this.props.pkLocalState.vtcoTwoFactorCode
		}

		_this.props.actions.premissionVtco(this.props.base.vtcoURL, data, this.props.pkLocalState.vtcoTokenBody, this.controller.signal)
		.then((response) => {

			if (response === "canceled") {
				_this.setState({isLoading: false})
				_this.setState({"showVtcoConfirmPopup": false})
                return;
            }

	    	if (response.code !== undefined) {
	    		if (response.code === "AUTHCOMMON-14") {
            		var currentCount = _this.state.numberOfPinInput

            		currentCount = currentCount - 1;

 					if (currentCount > 0) {
 						_this.setState({numberOfPinInput: currentCount});
						_this.setState({needToReEnterPin: true});
						_this.setState({showVtcoConfirmPopup: true})
 					} else {
 						_this.setState({numberOfPinInput: 0});
 						_this.setState({needToReEnterPin: false});
						_this.setState({showVtcoConfirmPopup: false})
						_this.setState({isLoading: false})
 					}
            	} else {
            		_this.setState({isLoading: false})
            		errorMessage = {
                      message: response.message,
                      techMessage: response.techMessage
                    }
                    _this.props.actions.setErrorData(errorMessage)
                    _this.props.actions.setShowErrorPopup(true)
		    		// var msg = response.message + "\n" + response.techMessage
		    		// alert(msg);
            	}
	    	} else {
	    		_this.decryptVtco();
	    	}
	    })
	}

	decryptVtco () {
		var _this = this, sendData, input, errorMessage;
		this.setState({isLoading: true})

		sendData = function () {
			var jsonObject = {
	        	pin : _this.props.pkLocalState.vtcoPin,
				dataToDecipher : [
					input
				]
		    };

		    var cipherResult = cipher(jsonObject, _this.props.pkLocalState.publicKeyTextual, _this.props.pkLocalState.currentUtcDateTime);

		    var data = {
		        "ciHsmTokenUri": _this.props.pkLocalState.vtcoSelectedKey.uri,
		        "encryptedData": cipherResult.encryptedData,
		        "secretKey": cipherResult.secretKey
		    }

		    _this.props.actions.decryptVtco(_this.props.base.vtcoURL, data, _this.props.pkLocalState.vtcoTokenBody)
		    .then((response) => {
		    	if (response.code !== undefined) {
		    		_this.setState({isLoading: false})
		    		errorMessage = {
                      message: response.message,
                      techMessage: response.techMessage
                    }
                    _this.props.actions.setErrorData(errorMessage)
                    _this.props.actions.setShowErrorPopup(true)

		    		// var msg = response.message + "\n" + response.techMessage
		    		// alert(msg);
		    	} else {
			    	_this.props.actions.setDecryptedData(response)
			    	_this.setState({"showVtcoConfirmPopup": false})
			    	_this.setState({isLoading: false})
		    	}
		    })
		}

		var reader = new FileReader();
        reader.readAsBinaryString(_this.props.defaultDecrState.fileForDecrypt);
        reader.onload = function (evt) {
            var binaryData = evt.target.result;
            var base64String = window.btoa(binaryData);

            input = base64String;
            sendData();

        }
        reader.onerror = function (evt) {
            document.getElementById("fileContents").innerHTML = "error reading file";
        }
	}

	decryptVTokenPass () {
		this.controller = new AbortController();
		var counter = 0, resultDataArray = [], _this = this, input, certData, sendData, errorMessage;
		this.setState({isLoading: true})
		this.setState({"successDecryption": false})
		this.setState({"success": 0})

		sendData = function () {
			var jsonObject = {
				dataToDecipher : [
					input
				]
		    };

		    _this.props.actions.getVtcoProtectedParams(_this.props.base.vtcoURL, _this.props.base.authJwt)
	        .then((response) => {
	            if (response.code !== undefined) {
	                console.log(response);
	                errorMessage = {
	                  message: response.message,
	                  techMessage: response.techMessage
	                }
	                _this.props.actions.setErrorData(errorMessage)
	                _this.props.actions.setShowErrorPopup(true)
	            } else {
	                _this.props.actions.setProtectedParams(response)
	                
	                console.log(response);
	                console.log(jsonObject);

	                var cipherResult = cipher(jsonObject, response.publicKeyTextual, response.currentUtcDateTime);

				    var data = {
				        "encryptedData": cipherResult.encryptedData,
				        "secretKey": cipherResult.secretKey
				    }

				    _this.props.actions.getVTokenMpo(_this.props.base.vtcoURL, _this.props.base.authJwt)
					.then((response) => {
						_this.setState({mpoTtlMillis: response.mpoTtlMillis / 1000})
			    		_this.props.actions.deciphermentVTokenPass(_this.props.base.vtcoURL, response.mpoId, data, _this.props.base.authJwt)
			    		.then((response) => {
					    	if (response.code !== undefined) {
					    		_this.setState({isLoading: false})
					    		errorMessage = {
			                      message: response.message,
			                      techMessage: response.techMessage
			                    }
			                    _this.props.actions.setErrorData(errorMessage)
			                    _this.props.actions.setShowErrorPopup(true)
					    	}

					    	console.log(response)

					    	var newQrImage = {
					    		version: response.version,
					    		mpoId: response.mpoId,
					    		vtokenUri: _this.props.base.vtcoURL
					    	}

					    	const imgForVTokenPass = JSON.stringify(newQrImage);
					    	_this.setState({base64ImgForVTokenPass: imgForVTokenPass})

							console.log(imgForVTokenPass);

					    	_this.setState({showVTokenPassConfirmPopup: true})

					    	_this.props.actions.getVTokenPassResult(_this.props.base.vtcoURL, response.mpoId, _this.props.base.authJwt, _this.controller.signal)
					    	.then((response) => {

					    		if (response === "canceled") {
									_this.setState({isLoading: false})
									_this.setState({"showVTokenPassConfirmPopup": false})
					                return;
					            }

						    	if (response.code !== undefined) {
						    		_this.setState({isLoading: false})
						    		_this.setState({"showVTokenPassConfirmPopup": false})
						    		errorMessage = {
				                      message: response.code === "CIHSMVTCOBASE-7" ? i18next.t("vTokenPassTimeOut") : response.message,
				                      techMessage: response.techMessage
				                    }
				                    _this.props.actions.setErrorData(errorMessage)
				                    _this.props.actions.setShowErrorPopup(true)
						    	} else {

							        if (response.code !== undefined) {
							    		_this.setState({isLoading: false})
							    		_this.setState({"showVtcoConfirmPopup": false})
							    		_this.setState({"showVTokenPassConfirmPopup": false})
							    		errorMessage = {
					                      message: response.message,
					                      techMessage: response.techMessage
					                    }
					                    _this.props.actions.setErrorData(errorMessage)
					                    _this.props.actions.setShowErrorPopup(true)
							    	} else {
							    		_this.props.actions.setDecryptedData(response)
							    		_this.setState({"showVTokenPassConfirmPopup": false})
			    						_this.setState({isLoading: false})
							    	}
						    	}
						    })
					    })
				    })
	            }
	        })
		}

		var reader = new FileReader();
        reader.readAsBinaryString(_this.props.defaultDecrState.fileForDecrypt);
        reader.onload = function (evt) {
            var binaryData = evt.target.result;
            var base64String = window.btoa(binaryData);

            input = base64String;
            sendData();

        }
        reader.onerror = function (evt) {
            document.getElementById("fileContents").innerHTML = "error reading file";
        }
	}

	decrypt() {
		var url, _this = this, errorMessage;
		let settedToken

		if (this.props.base.isVtco) {
			if (this.props.pkLocalState.isTwoFactorEnable) {
				var data = {
				    "ciHsmTokenUri": this.props.pkLocalState.vtcoSelectedKey.uri,
				    "operationType": "DECIPHERMENT",
				    "permissionTtlSeconds" : 10,
				    "permissionRepetition" : 2
				}

				this.props.actions.premission2fVtco(this.props.base.vtcoURL, data, this.props.pkLocalState.vtcoTokenBody)
			    .then((response) => {

			    	if ((response.processingType !== null && response.processingType !== undefined) && response.processingType === "V_TOKEN_PASS") {
	                    this.props.actions.setInputTypeFor2F("image")
	                    this.props.actions.setImageFor2F(response.processingData.qrCodePngData)
	                    this.decryptVtco2f();
	                } else {
	                    if (response.codeTtl !== null && response.codeTtl !== undefined) {
	                    	_this.setState({codeTtl: response.codeTtl}, () => {_this.props.actions.setInputTypeFor2F("text")}, () => {_this.props.actions.setImageFor2F(null)})
	                    }
	                }

			    	if (response.code !== undefined) {
			    		_this.setState({isLoading: false})
			    		errorMessage = {
	                      message: response.message,
	                      techMessage: response.techMessage
	                    }
	                    _this.props.actions.setErrorData(errorMessage)
	                    _this.props.actions.setShowErrorPopup(true)
			    		// var msg = response.message + "\n" + response.techMessage
			    		// alert(msg);
			    	} else {
			    		this.selectDecryptVtco();
			    	}
			    })
			} else {
				this.selectDecryptVtco();
			}

			return;
		}

		if (this.props.base.isVTokenPass) {
			this.decryptVTokenPass()
			return;
		}

		if (this.props.pkLocalState.useUccConnection) {
			url = this.props.base.urlUCC + "/api/v1"
		} else {
			url = this.props.base.urlCloud + "/api/v1"
		}

		if (this.props.pkLocalState.tokenPathHSM.length > 0) {
			settedToken = {
				keyStoreUri: this.props.pkLocalState.tokenPathHSM
			}
		} else {
			if (this.props.pkLocalState.depositsignSelectedKey !== null) {
				settedToken = {
					keyStoreUri: this.props.pkLocalState.depositsignSelectedKey.KeyName
				}
			} else {
				settedToken = {
					keyStorePath: this.props.pkLocalState.activeToken ? this.props.pkLocalState.activeToken : this.props.pkLocalState.passiveToken
				}
			}
		}

		let caId = {
	        caId: this.props.pkLocalState.selectedKeyContainer
	    }

		if (this.props.pkLocalState.keyContainer !== null) {
			if (this.props.connectionStatus.uccConnection && typeof this.props.pkLocalState.keyContainer === 'string') {
				let keyPath = {"keyStorePath": this.props.pkLocalState.keyContainer}
	            this.setState({"settedToken": keyPath})
	            this.setState({"caId": caId})
	            this.withToken()
			} else {
				this.setState({isLoading: true})
				this.props.actions.createSession(url, _this.props.pkLocalState.useUccConnection ? null : _this.props.base.token)
		        	.then((response) => {
						this.setState({uuid: response.ticketUuid})
						console.log(response);
					return this.props.actions.sendInputData(url, this.state.uuid, this.props.defaultDecrState.fileForDecrypt, _this.props.pkLocalState.useUccConnection ? null : _this.props.base.token)
						.then(() => this.props.actions.sendSessionOption(url, this.state.uuid, caId, _this.props.pkLocalState.useUccConnection ? null : _this.props.base.token))
			            .then(() => this.props.actions.sendKeyContainer(url, this.state.uuid, this.props.pkLocalState.keyContainer, _this.props.pkLocalState.useUccConnection ? null : _this.props.base.token))
		            	.then(() => this.props.actions.decryptData(url, this.state.uuid, this.props.pkLocalState.keyContainerPassword, _this.props.pkLocalState.useUccConnection ? null : _this.props.base.token))
			            .then(() => this.props.actions.getDecryptedData(url, this.state.uuid, _this.props.pkLocalState.useUccConnection ? null : _this.props.base.token))
			           	.then((response) => {
			           		if (response !== null) {
		            			this.props.actions.setDecryptedData(response)
		            		}
		                })
		                .then(() => this.props.actions.getDecryptorStatus(url, this.state.uuid, _this.props.pkLocalState.useUccConnection ? null : _this.props.base.token))
		                .then((response) => {
		                	if (response.failureCause !== undefined && response.failureCause.length > 0) {
		                    	console.log(response)
		                    	errorMessage = {
			                      message: response.message,
			                      techMessage: response.failureCause
			                    }
			                    _this.props.actions.setErrorData(errorMessage)
			                    _this.props.actions.setShowErrorPopup(true)

		                    	// alert(response.failureCause)
		            		} else {
		            			// alert(i18next.t("dec:decryptedDataDownloadedSuccess": "decryptedDataDownloadedSuccess"))
		            		}
		            		this.setState({isLoading: false})
		                })
			            .then(() => this.props.actions.deleteSession(url, this.state.uuid, _this.props.pkLocalState.useUccConnection ? null : _this.props.base.token))
		        })
		    }
		} else {
			this.setState({"settedToken": settedToken})
            this.setState({"caId": caId})
            this.withToken()
		}
    }

	render() {
		const isEnabled = this.props.defaultDecrState.fileForDecryptSelected && !this.state.isLoading
		const downloadEnable = this.props.defaultDecrState.decrData && this.state.downloadIsAvailable
		return (
            <div className="row" style={{paddingTop: "10px"}}>
				<div className="col-12">
	                <div className="card">
						<div className="card-header" onClick={this.expandDecrypt.bind(this)} role="button">
							{
								this.props.expandedCardsReducer.decryptExpanded ? <i className="fa fa-chevron-down" aria-hidden="true" style={{"cursor": "pointer"}}></i>
								: <i className="fa fa-chevron-up" aria-hidden="true" style={{"cursor": "pointer"}}></i>
							}&nbsp;{i18next.t("file")}
						</div>
	                  	<div className={this.state.collapseDecryptShow}>
	                  		<div className="row">
		                  		<label className="col-lg-4 col-md-4 col-xs-12 col-sm-12 col-form-label">{i18next.t("dec:encryptedFileTitle")}</label>
	                            <div className="col-lg-8 col-md-8 col-xs-12 col-sm-12" style={{marginBottom: "10px"}}>
	                                {
	                                  this.props.mobileModeReducer.mobileDeviceMode
	                                  ? 
	                                  <div className="input-group row" style={{marginLeft: "0px"}}>
	                                    <input type="text" className="form-control col-lg-8 col-md-8 col-xs-12 col-sm-12" value={this.props.defaultDecrState.fileForDecryptName} style={{"backgroundColor": "white", "cursor": "pointer"}} onClick={this.handleFileForDecrypt.bind(this)} readOnly />
	                                    {
											this.props.defaultDecrState.fileForDecryptSelected
											? <button className="btn btn-default col-lg-4 col-md-4 col-xs-12 col-sm-12 margin-top-sm" style={{"cursor": "pointer"}} onClick={this.handleFileForDecrypt.bind(this)}>{i18next.t("changeFile")}</button>
											: <button className="btn btn-default col-lg-4 col-md-4 col-xs-12 col-sm-12 margin-top-sm" style={{"cursor": "pointer"}} onClick={this.handleFileForDecrypt.bind(this)}>{i18next.t("chooseFile")}</button>
										}
	                                    </div>
	                                    : <div>
	                                    	{
	                                    		this.props.defaultDecrState.fileForDecryptSelected
	                                    		? <div className="input-group mb-3">
													<input type="text" className="form-control col-lg-8 col-md-8 col-xs-12 col-sm-12 max-width" value={this.props.defaultDecrState.fileForDecryptName} style={{"backgroundColor": "white", "cursor": "pointer"}} onClick={this.handleFileForDecrypt.bind(this)} readOnly />
		                                    		<div className="input-group-append">
												      
													    <button className="input-group-text" style={{"cursor": "pointer"}} onClick={this.cleanUpFileForDecrypt.bind(this)}>{i18next.t("cleanup")}</button>
												    </div>
												</div>
											    : <Dropzone ref={dropzoneRef} onDrop={this.handleOnDrop} multiple={false}>
							                        {({getRootProps, getInputProps}) => (
							                            <div {...getRootProps()} style={{cursor: "pointer", marginBottom: "8px"}} className="dropzone" id="dropFile">
							                                <input {...getInputProps()} />
							                                <p style={{cursor: "pointer", marginTop: "16px"}}>{i18next.t("dragNDropTitleSecond")}</p>
							                            </div>
							                        )}
							                    </Dropzone>
	                                    	}
										</div>
	                                }
	                                <input id="fileForDecryptUpload" type="file" onChange={this.onChangeFileForDecrypt.bind(this)} style={{"display": "none"}} />
	                            </div>
	                        </div>
							<div className="row">
								<div className="col-lg-4 col-md-6 col-sm-12 col-xs-12 order-0 order-md-4">
									<button className="btn btn-default col-lg-12 col-md-12 col-sm-12 col-xs-12" style={{marginBottom: "10px"}} onClick={this.decrypt.bind(this)} disabled={!isEnabled}>{i18next.t("dec:performBinaryDataDecryption")}
										{
			                                this.state.isLoading ? <span>&nbsp;<i className="fa fa-spinner fa-pulse"></i></span>
			                                : null
			                            }
									</button>
								</div>
								<div className="col-lg-5 col-md-12 col-sm-12 col-xs-12 order-1 order-lg-5 no-left-padding">
		                        	<button className="btn btn-default col-lg-12 col-md-12 col-sm-12 col-xs-12" style={{marginBottom: "10px", whiteSpace: "normal"}} disabled={!downloadEnable} onClick={this.getBlobData.bind(this)}>{i18next.t("dec:saveBinaryDecryptedData")}</button>
		                        </div>
		                        <div className="col-lg-3 col-md-6 col-sm-12 col-xs-12 order-2 order-md-6 no-left-padding">
		                        	<button className="btn btn-default col-lg-12 col-md-12 col-sm-12 col-xs-12" disabled={this.state.isLoading} onClick={this.cleanUpForm.bind(this)}>{i18next.t("cleanUpForm")}</button>
		                        </div>
	                        </div>
	                    </div>
	                </div>
	                <DecryptTextContainer />
	                {
						this.state.showVtcoConfirmPopup
						? <TwoFactorConfirmPopup initAction={this.closeVtcoConfirm.bind(this)} cancelRequest={this.cancelRequest} codeTtl={this.state.codeTtl} title={"decryptConfirm"} tries={this.state.numberOfPinInput} />
						: null
					}
					{
						this.state.showVTokenPassConfirmPopup
						? <VTokenPassConfirmPopup image={this.state.base64ImgForVTokenPass} mpoTtlMillis={this.state.mpoTtlMillis} cancelRequest={this.cancelRequest} title={"decryptVtokenPassTitle"} />
						: null
					}
                </div>
            </div>
		);
	}
}

function mapStateToProps(state) {
    return {
    	base: state.base,
        locales: state.i18n,
        localesReducer: state.localesReducer,
        pkLocalState: state.privateKeyReducer,
        defaultDecrState: state.decryptReducer,
        connectionStatus: state.connectionStatusReucer,
        mobileModeReducer: state.mobileModeReducer,
        expandedCardsReducer: state.expandedCardsReducer
    }
}

const mapDispatchToProps = (dispatch) => {
    const actions = {
	    languageSwitchItem,
	    createSession,
	    sendInputData,
	    sendSessionOption,
	    sendKeyContainer,
	    decryptData,
	    getDecryptedData,
	    deleteSession,
	    setInputFileForDecrypt,
	    clearInputFileForDecrypt,
	    setDecryptedData,
	    clearDecryptedData,
	    sendTokenPath,
	    getDecryptorStatus,
	    setDecryptExpand, decryptVtco,
	    cipher, premission2fVtco, premissionVtco,
	    setErrorData, setShowErrorPopup,
	    getVTokenMpo, deciphermentVTokenPass, getVTokenPassResult, getVtcoProtectedParams,
	    setInputTypeFor2F, setImageFor2F, setProtectedParams
    };
    return {
       actions: bindActionCreators(actions, dispatch)
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(DecryptContainer);